<template>
  <spinner v-if="loading > 0"></spinner>
  <main v-else>
    <app-banner :num="(num_rows) ? num_rows : 0"></app-banner>
    <section class="row-3" v-if="arbitres && arbitres.length === 0">
      <p class="text-info">
        Aucun arbitre enregistré dans le système !<br>
        <button v-b-modal.modal-ajouter-arbitres class="mt-2 btn btn-outline-info">Ajouter</button>
      </p>
    </section>
    <section v-if="arbitres && arbitres.length !== 0" class="d-flex flex-row flex-wrap justify-content-between row-2">
      <div class="w-40 input-group flex-nowrap column-left">
        <input type="text" class="form-control" placeholder="Rechercher..." aria-label="Username" aria-describedby="addon-wrapping">
        <div class="input-group-prepend">
            <span class="input-group-text" id="addon-wrapping">
              <font-awesome-icon :icon="['fas', 'search']"></font-awesome-icon>
            </span>
        </div>
      </div>
      <div class="column-right">
        <button class="btn">
          <font-awesome-icon :icon="['fas', 'sort']"></font-awesome-icon>
          <span>A-Z</span>
        </button>
        <button class="btn">
          <font-awesome-icon :icon="['fas', 'sort']"></font-awesome-icon>
          <span>Date</span>
        </button>
      </div>
    </section>
    <hr>
    <section v-if="arbitres && arbitres.length !== 0" class="row-3">
      <ul class="list-group">
        <li class="list-group-item active d-flex flex-row justify-content-between">
          <div>NOMS</div>
          <div>OPTIONS</div>
        </li>
        <li :key="arbitre.arbitre_id.slice(5,10)" v-for="(arbitre, idx) in arbitres">
          <div class="d-flex flex-row flex-wrap flex-md-nowrap justify-content-between list-group-item">
            <div class="w-100 w-md-50 text-center text-md-left">
              <img class="img-fluid img-thumbnail customizedSizeImage"
                   v-if="arbitre.photo_passeport === '' || !arbitre.photo_passeport"
                   v-b-modal="'modal-photo-' + arbitre.arbitre_id.slice(3,13)"
                   :alt="arbitre.prenom + ' ' + arbitre.postnom + ' ' + arbitre.nom"
                   :title="arbitre.prenom + ' ' + arbitre.postnom + ' ' + arbitre.nom"
                   src="http://admin.fcrobi.com/assets/img/icon-user.png">
              <img v-else class="img-fluid img-thumbnail customizedSizeImage"
                   v-b-modal="'modal-photo-' + arbitre.arbitre_id.slice(3,13)"
                   :alt="arbitre.prenom + ' ' + arbitre.postnom + ' ' + arbitre.nom"
                   :title="arbitre.prenom + ' ' + arbitre.postnom + ' ' + arbitre.nom"
                   :src="getBaseFileURL + arbitre.photo_passeport">
              {{ arbitre.prenom.charAt(0).toUpperCase() + arbitre.prenom.slice(1).toLowerCase() }}
              {{ arbitre.postnom.charAt(0).toUpperCase() + arbitre.postnom.slice(1).toLowerCase() }}
              {{ arbitre.nom.charAt(0).toUpperCase() + arbitre.nom.slice(1).toLowerCase() }}
            </div>
            <div class="mt-2 mt-md-0 w-100 w-md-30 d-flex flex-row justify-content-around">
              <div class="div-icon-read" v-b-toggle="'collapse' + idx" @click="selectedComponent = 'AppRead'">
                <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>
              </div>
              <div class="div-icon-update" v-b-toggle="'collapse' + idx" @click="selectedComponent = 'AppUpdate'">
                <font-awesome-icon :icon="['fas', 'pen']"></font-awesome-icon>
              </div>
              <div class="div-icon-delete" v-b-toggle="'collapse' + idx" @click="selectedComponent = 'AppDelete'">
                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
              </div>
            </div>
          </div>
          <b-collapse :id="'collapse' + idx" class="list-group-item">
            <keep-alive>
              <component :is="selectedComponent" :arbitre="arbitre"></component>
            </keep-alive>
          </b-collapse>
          <!-- Debut modal affichage photo -->
          <b-modal hide-footer
                   hide-header
                   :id="'modal-photo-' + arbitre.arbitre_id.slice(3,13)"
                   centered>
            <div>
              <img v-if="arbitre.photo_passeport === '' || !arbitre.photo_passeport" class="img-fluid"
                   :alt="arbitre.prenom + ' ' + arbitre.postnom + ' ' + arbitre.nom"
                   :title="arbitre.prenom + ' ' + arbitre.postnom + ' ' + arbitre.nom"
                   src="http://admin.fcrobi.com/assets/img/icon-user.png">
              <img v-else class="img-fluid"
                   :alt="arbitre.prenom + ' ' + arbitre.postnom + ' ' + arbitre.nom"
                   :title="arbitre.prenom + ' ' + arbitre.postnom + ' ' + arbitre.nom"
                   :src="getBaseFileURL + arbitre.photo_passeport">
            </div>
          </b-modal>
          <!-- Fin modal affichage photo -->
        </li>
      </ul>
    </section>
    <aside v-if="(num_rows && num_rows > dataForm.pageNum)" class="text-white bg-color-light-golden-orange text-center">
      {{ currentIndex }} / {{ Math.ceil(num_rows / dataForm.pageNum) }}
    </aside>
    <section v-if="(num_rows && num_rows > dataForm.pageNum)" class="d-flex flex-row justify-content-center row-4">
      <nav aria-label="Page navigation">
        <ul class="pagination">
          <li class="page-item cursor-pointer" @click="previous()">
            <a :class="(dataForm.pageIdx - dataForm.pageNum < 0) ? 'page-link pagination-disabled' : 'page-link'">Précédent</a>
          </li>
          <li class="page-item cursor-pointer" @click="next()">
            <a :class="(dataForm.pageIdx + dataForm.pageNum > num_rows) ? 'page-link pagination-disabled' : 'page-link'">Suivant</a>
          </li>
        </ul>
      </nav>
    </section>
  </main>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'
import Read from "./components/Read";
import Update from "./components/Update";
import Delete from "./components/Delete";
import Banner from "../shared/Banner"
import Spinner from "../shared/Spinner"

export default {
  name: "Arbitres",
  props: {},
  data(){
    return{
      arbitres: null,
      selectedComponent: 'AppRead',
      num_rows: '',
      currentIndex: 1,
      error: '',
      loading: 2,
      dataForm: {
        table: 'arbitres',
        pageIdx: 0,
        pageNum: 10,
      }
    }
  },
  components: {
    Spinner,
    AppRead: Read,
    AppUpdate: Update,
    AppDelete: Delete,
    AppBanner: Banner
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosGetPaginatedData',
      'axiosGetNumRows',
    ]),
    previous(){
      if(!(this.dataForm.pageIdx - this.dataForm.pageNum < 0)){
        this.dataForm.pageIdx -= this.dataForm.pageNum
        this.currentIndex--
        this.loading++
      }
      //
      this.axiosGetPaginatedData(this.dataForm)
          .then((data) => {
            this.arbitres = data.data
            this.loading--
          })
          .catch((data) => {
            this.arbitres = data
          })
    },
    next(){
      if(!(this.dataForm.pageIdx + this.dataForm.pageNum > this.num_rows)){
        this.dataForm.pageIdx += this.dataForm.pageNum
        this.currentIndex++
        this.loading++
      }
      //
      this.axiosGetPaginatedData(this.dataForm)
          .then((data) => {
            this.arbitres = data.data
            this.loading--
          })
          .catch((data) => {
            this.arbitres = data
          })
    },
  },
  computed: {
    ...mapGetters([
        'getBaseFileURL'
    ])
  },
  beforeCreate() {},
  created() {
    //
    this.axiosGetNumRows({
      table: 'arbitres'
    })
      .then((data) => {
        this.num_rows = parseInt(data.data[0][0])
        this.loading--
      })
      .catch((error) => this.error = error)
    //
    this.axiosGetPaginatedData(this.dataForm)
      .then((data) => {
        this.arbitres = data.data
        this.loading--
      })
      .catch((data) => {
        this.arbitres = data
      })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
@import "../../../src/assets/css/customized/main_right";
</style>



// WEBPACK FOOTER //
// src/components/arbitres/Arbitres.vue